import type { Chapter } from "@/types/drama";

type Props = {
  chapters: Chapter[];
  activeIndex: number;
  onSelect: (index: number) => void;
};

export default function EpisodeList({ chapters, activeIndex, onSelect }: Props) {
  return (
    <div>
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
          <span className="flex h-5 w-5 items-center justify-center text-primary-500">
            <i className="ri-list-ordered text-base"></i>
          </span>
          章节目录
        </h2>
        <span className="font-label text-[11px] text-foreground-500">点击章节查看简介</span>
      </div>

      <div className="mt-3 flex gap-2 overflow-x-auto pb-1 no-scrollbar md:grid md:grid-cols-2 md:gap-2.5 lg:grid-cols-3 md:overflow-visible">
        {chapters.map((chapter) => {
          const active = chapter.index === activeIndex;
          return (
            <button
              key={chapter.index}
              type="button"
              onClick={() => onSelect(chapter.index)}
              className={`flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border px-3 py-2.5 font-label text-xs transition-colors md:whitespace-normal md:text-left ${
                active
                  ? "border-primary-500 bg-primary-500/12 text-primary-500"
                  : "border-background-200/70 bg-background-100 text-foreground-700 hover:border-primary-400/70 hover:text-foreground-950"
              }`}
            >
              <span
                className={`flex h-5 w-5 shrink-0 items-center justify-center rounded text-[10px] ${
                  active ? "bg-primary-500 text-background-50" : "bg-background-200/80 text-foreground-600"
                }`}
              >
                {chapter.index}
              </span>
              <span className="truncate md:line-clamp-1">{chapter.title}</span>
            </button>
          );
        })}
      </div>

      <div className="mt-3 rounded-md border border-background-200/70 bg-background-100/60 p-3.5">
        <p className="font-label text-[11px] tracking-[0.18em] text-accent-600">
          第 {activeIndex} 集剧情
        </p>
        <p className="mt-1.5 text-xs leading-relaxed text-foreground-700">
          {chapters.find((chapter) => chapter.index === activeIndex)?.summary}
        </p>
      </div>
    </div>
  );
}